import React, { useState, useEffect } from 'react';

interface RenderNextAnimationFrameProps {
	delay?: number;
	children: () => React.ReactNode;
}

const RenderNextAnimationFrame: React.FC<RenderNextAnimationFrameProps> = ({ delay, children }) => {
	const [render, setRender] = useState(false);

	useEffect(() => {
		const renderNextAnimationFrame = () => {
			globalThis.window.requestAnimationFrame(() => {
				globalThis.window.requestAnimationFrame(() => {
					setRender(true);
				});
			});
		};

		if (delay) {
			const timer = globalThis.window.setTimeout(renderNextAnimationFrame, delay);
			return () => clearTimeout(timer);
		}
		renderNextAnimationFrame();
	}, [delay]);

	return render ? <>{children()}</> : null;
};

export default RenderNextAnimationFrame;
